module.exports = __webpack_public_path__ + "img/13.ba452c46.png";